(() => {
  function init(root) {
    if (!root || root.dataset.editorialReady) return;
    root.dataset.editorialReady = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduced) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0, rootMargin: '0px 0px -32px' });
      root.classList.add('ov-reveal-ready');
      root.querySelectorAll('.ov-reveal').forEach(section => observer.observe(section));
      const words = [...root.querySelectorAll('[data-ov-tagline] span')];
      const wordObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.style.transitionDelay = `${words.indexOf(entry.target) * 100}ms`;
        entry.target.classList.add('is-read'); wordObserver.unobserve(entry.target);
      }), { rootMargin: '0px 0px -25%' });
      root.classList.add('ov-tagline-ready'); words.forEach(word => wordObserver.observe(word));
    }
    const carousel = root.querySelector('[data-ov-carousel]');
    if (!carousel) return;
    const slides = [...carousel.querySelectorAll('[data-ov-slide]')];
    const dots = [...carousel.querySelectorAll('[data-ov-dot]')];
    const current = carousel.querySelector('[data-ov-current]');
    const title = carousel.querySelector('[data-ov-title]');
    let titles = [], index = 0;
    try { titles = JSON.parse(carousel.querySelector('[data-ov-slide-titles]').textContent); } catch (_) {}
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-current', String(i === index)); });
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      if (title) title.textContent = titles[index] || '';
    };
    // Keep product photography still while visitors read. Navigation is deliberate.
    carousel.querySelector('[data-ov-prev]')?.addEventListener('click', () => show(index - 1));
    carousel.querySelector('[data-ov-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    let touch = null;
    carousel.addEventListener('touchstart', e => { touch = e.touches[0]; }, { passive: true });
    carousel.addEventListener('touchend', e => {
      if (!touch) return;
      const dx = e.changedTouches[0].clientX - touch.clientX, dy = e.changedTouches[0].clientY - touch.clientY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
      touch = null;
    }, { passive: true });
    show(0);
  }
  init(document.querySelector('[data-orevyr-home]'));
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-orevyr-home]')));
})();
